import { useQuery } from "@tanstack/react-query";
import { axiosInstance } from "../../../js/api/axios";

export const fetchColourMatched = async (rgbCode, { signal } = {}) => {
  let response;
  try {
    response = await axiosInstance.get(
      `/colourWheelApi/getColourMatched/?rgbCode=${rgbCode}`,
      { signal }
    );
  } catch (err) {
    throw new Error(err.message);
  }

  const { status, data } = response;

  const isEmptyObject = !!data && typeof data === "object" && Object.keys(data).length === 0;
  const isMissing = data == null;

  if (status === 204 || isMissing || isEmptyObject) {
    throw new Error("No colour match data");
  }

  return data;
};

export const useColourMatched = (rgbCode) => {
  return useQuery({
    queryKey: ["colour-matched", rgbCode],
    queryFn: ({ signal }) => fetchColourMatched(rgbCode, { signal }),
    retry: 3,
    retryDelay: 1000,
    enabled: !!rgbCode,
  });
};
